import ValueCompared from './ValueCompared';

export default ValueCompared;
